import { useState } from "react";
import PropTypes from "prop-types";

import Popover from "@mui/material/Popover";
import TableRow from "@mui/material/TableRow";

import MenuItem from "@mui/material/MenuItem";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import Iconify from "../../components/iconify";
import { CircularProgress, Fade } from "@mui/material";
import { useDispatch } from "react-redux";
import { deleteBranch, updateBranch } from "../../features/dataAction";
import EditBranchModal from "./view/EditBranchModal";
import DeleteBrand from "./view/DeleteBrand";
import toast from "react-hot-toast";

// ----------------------------------------------------------------------

export default function BranchTableRow({
  id,
  name,
  address,
  phone,
  adminUser,
  page,
  perPage,
}) {
  const [open, setOpen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false)
  const [selectedBranchData, setSelectedBranchData] = useState({});
  const dispatch = useDispatch();
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };
  const handleEditClick = () => {
    setSelectedBranchData({ id, name, address, phone });
    setEditModalOpen(true);
    handleCloseMenu();
  };
  const handleCloseMenu = () => {
    setOpen(null);
  };
  const handleCloseDeleteModel = () => {
    setDeleteOpen(false)
    handleCloseMenu()
  }
  const handleEditSave = (updatedData) => {
    setLoading(true);
    dispatch(updateBranch(page + 1, perPage, updatedData, (error) => {
      if (error) {
        toast.error(error)
      }
    }));
  };
  const handleDelete = () => {
    setLoading(true);
    dispatch(deleteBranch(id, page + 1, perPage, (error) => {
      if (error) {
        toast.error(error)
      }
    }));
    handleCloseMenu();
  };

  return (
    <>
      {loading && (
        <TableRow>
          <TableCell colSpan={7} align="center">
            <CircularProgress size={24} />
          </TableCell>
        </TableRow>
      )}
      <Fade in timeout={400}>
        <TableRow hover tabIndex={-1} role="checkbox">
          <TableCell>{id}</TableCell>

          <TableCell component="th" scope="row" padding="none">
            <Typography variant="subtitle2" noWrap>
              {name}
            </Typography>
          </TableCell>

          <TableCell>{address}</TableCell>

          <TableCell>{phone}</TableCell>

          <TableCell>{adminUser}</TableCell>

          <TableCell>
            <IconButton onClick={handleOpenMenu}>
              <Iconify icon="eva:more-vertical-fill" />
            </IconButton>
          </TableCell>
        </TableRow>
      </Fade>
      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: { width: 140 },
        }}
      >
        <MenuItem onClick={handleEditClick}>
          <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem onClick={() => setDeleteOpen(true)} sx={{ color: "error.main" }}>
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
      {isEditModalOpen && (
        <EditBranchModal
          open={isEditModalOpen}
          handleClose={() => setEditModalOpen(false)}
          branchData={selectedBranchData}
          handleSave={handleEditSave}
        />
      )}
      <DeleteBrand
        open={deleteOpen}
        handleClose={handleCloseDeleteModel}
        handleDelete={handleDelete}
        name={'Branch'}
      />
    </>
  );
}

BranchTableRow.propTypes = {
  id: PropTypes.any,

  address: PropTypes.any,
  phone: PropTypes.any,
  handleClick: PropTypes.func,
  adminUser: PropTypes.any,
  name: PropTypes.any,


};
